import * as Yup from "yup";

const enderecoEstoqueValidator = Yup.object().shape({
  endereco: Yup.string().required("Descrição do Endereço"),
});

export default enderecoEstoqueValidator;
